(function () {
  function parseReview(card) {
    const node = card.querySelector('[data-crs-review-json]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function renderStars(count) {
    let html = '';
    for (let i = 1; i <= 5; i += 1) {
      html += '<span class="crs__star' + (i > count ? ' is-empty' : '') + '">&#9733;</span>';
    }
    return html;
  }

  function initSection(root) {
    if (!root || root.dataset.crsReady === 'true') return;

    const grid = root.querySelector('[data-crs-grid]');
    const modal = root.querySelector('[data-crs-modal]');
    const modalMedia = root.querySelector('[data-crs-modal-media]');
    const modalStars = root.querySelector('[data-crs-modal-stars]');
    const modalAuthor = root.querySelector('[data-crs-modal-author]');
    const modalDate = root.querySelector('[data-crs-modal-date]');
    const modalVerified = root.querySelector('[data-crs-modal-verified]');
    const modalThumbs = root.querySelector('[data-crs-modal-thumbs]');
    const modalText = root.querySelector('[data-crs-modal-text]');
    const sortToggle = root.querySelector('[data-crs-sort-toggle]');
    const sortMenu = root.querySelector('[data-crs-sort-menu]');

    if (!grid || !modal || !modalMedia || !modalAuthor || !modalText) return;
    root.dataset.crsReady = 'true';

    let activeReview = null;
    let activeImageIndex = 0;

    function getCards() {
      return Array.from(root.querySelectorAll('[data-crs-card]'));
    }

    function sortCards(mode) {
      const cards = getCards();
      const sorted = cards.slice().sort(function (a, b) {
        const rankA = Number(a.dataset.featuredRank || 0);
        const rankB = Number(b.dataset.featuredRank || 0);
        const photoA = Number(a.dataset.hasPhoto || 0);
        const photoB = Number(b.dataset.hasPhoto || 0);
        const ratingA = Number(a.dataset.rating || 0);
        const ratingB = Number(b.dataset.rating || 0);
        const dateA = new Date(a.dataset.date || '1970-01-01').getTime();
        const dateB = new Date(b.dataset.date || '1970-01-01').getTime();

        if (mode === 'photo') {
          if (photoB !== photoA) return photoB - photoA;
          return rankA - rankB;
        }

        if (mode === 'newest') {
          return dateB - dateA;
        }

        if (mode === 'highest') {
          if (ratingB !== ratingA) return ratingB - ratingA;
          return rankA - rankB;
        }

        if (mode === 'lowest') {
          if (ratingA !== ratingB) return ratingA - ratingB;
          return rankA - rankB;
        }

        return rankA - rankB;
      });

      sorted.forEach(function (card) {
        grid.appendChild(card);
      });

      root.querySelectorAll('[data-crs-sort-option]').forEach(function (button) {
        button.classList.toggle('is-active', button.dataset.crsSortOption === mode);
      });
    }

    function renderModalImage() {
      if (!activeReview || !activeReview.images || !activeReview.images.length) {
        modalMedia.innerHTML = '';
        modalThumbs.innerHTML = '';
        return;
      }

      const image = activeReview.images[activeImageIndex];
      modalMedia.innerHTML = '<img src="' + image.src + '" alt="' + (activeReview.author || 'Review image') + '">';

      modalThumbs.innerHTML = activeReview.images
        .map(function (item, index) {
          return (
            '<button class="crs-modal__thumb' +
            (index === activeImageIndex ? ' is-active' : '') +
            '" type="button" data-crs-thumb-index="' +
            index +
            '">' +
            '<img src="' +
            item.thumb +
            '" alt="Review thumbnail">' +
            '</button>'
          );
        })
        .join('');
    }

    function openModal(card) {
      const review = parseReview(card);
      if (!review) return;

      activeReview = review;
      activeImageIndex = 0;

      modalStars.innerHTML = renderStars(Number(review.rating || 5));
      modalAuthor.textContent = review.author || '';
      if (modalDate) modalDate.textContent = review.date || '';
      modalText.textContent = review.reviewText || '';

      if (review.verified) {
        modalVerified.hidden = false;
      } else {
        modalVerified.hidden = true;
      }

      renderModalImage();
      modal.hidden = false;
      document.documentElement.classList.add('overflow-hidden');
      document.body.classList.add('overflow-hidden');
    }

    function closeModal() {
      modal.hidden = true;
      activeReview = null;
      activeImageIndex = 0;
      document.documentElement.classList.remove('overflow-hidden');
      document.body.classList.remove('overflow-hidden');
    }

    root.addEventListener('click', function (event) {
      const openButton = event.target.closest('[data-crs-open-modal]');
      if (openButton) {
        event.preventDefault();
        openModal(openButton.closest('[data-crs-card]'));
        return;
      }

      const closeButton = event.target.closest('[data-crs-close-modal]');
      if (closeButton) {
        event.preventDefault();
        closeModal();
        return;
      }

      const sortOption = event.target.closest('[data-crs-sort-option]');
      if (sortOption) {
        event.preventDefault();
        sortCards(sortOption.dataset.crsSortOption);
        if (sortMenu) sortMenu.hidden = true;
        if (sortToggle) sortToggle.setAttribute('aria-expanded', 'false');
        return;
      }

      const thumb = event.target.closest('[data-crs-thumb-index]');
      if (thumb && activeReview) {
        event.preventDefault();
        activeImageIndex = Number(thumb.dataset.crsThumbIndex || 0);
        renderModalImage();
        return;
      }

      const prev = event.target.closest('[data-crs-prev]');
      if (prev && activeReview && activeReview.images && activeReview.images.length) {
        event.preventDefault();
        activeImageIndex = (activeImageIndex - 1 + activeReview.images.length) % activeReview.images.length;
        renderModalImage();
        return;
      }

      const next = event.target.closest('[data-crs-next]');
      if (next && activeReview && activeReview.images && activeReview.images.length) {
        event.preventDefault();
        activeImageIndex = (activeImageIndex + 1) % activeReview.images.length;
        renderModalImage();
        return;
      }

      if (sortMenu && !sortMenu.hidden && !event.target.closest('[data-crs-sort]')) {
        sortMenu.hidden = true;
        if (sortToggle) sortToggle.setAttribute('aria-expanded', 'false');
      }
    });

    if (sortToggle && sortMenu) {
      sortToggle.addEventListener('click', function () {
        const isOpen = !sortMenu.hidden;
        sortMenu.hidden = isOpen;
        sortToggle.setAttribute('aria-expanded', String(!isOpen));
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) {
        closeModal();
      }
    });

    sortCards(root.dataset.defaultSort || 'photo');
  }

  function initAll(container) {
    (container || document).querySelectorAll('[data-crs-root]').forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
